import { FC, ReactNode } from 'react'
import { CardContainer, Content, Title, TitleWrapper } from './styles'
import CardIcon from './CardIcon'

export interface InfoCardProps {
	title: ReactNode
	content: ReactNode
	iconType?: 'robux' | 'money' | 'rate' | 'total' | 'preorders'
}

const InfoCard: FC<InfoCardProps> = ({ content, title, iconType }) => {
	return (
		<CardContainer>
			<TitleWrapper>
				{iconType && <CardIcon type={iconType} />}
				<Title>{title}</Title>
			</TitleWrapper>
			<Content>{content}</Content>
		</CardContainer>
	)
}

export default InfoCard
